import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages } from "react-intl";

import globalMessages from "../../intl/globalMessages";

const messages = defineMessages({
  ...globalMessages,
  reservationId: {
    id: "app.swalTestEmailForm.reservationId",
    description: "Placeholder for reservationID input",
    defaultMessage: "Reservation ID",
  },
  destinationEmail: {
    id: "app.swalTestEmailForm.destinationEmail",
    description: "Placeholder for emails input",
    defaultMessage: "Destination emails",
  },
  motor: {
    id: "app.swalTestEmailForm.motor",
    description: "Label for the child engine (motor) selector",
    defaultMessage: "Motor",
  },
});

class SwalTestEmailForm extends Component {
  state = {
    destinationEmail: this.props.destinationEmail,
    reservationId: this.props.reservationId,
    motor: this.props.motor,
  };

  emit(partial) {
    const formValues = { ...this.state, ...partial };
    this.setState(formValues);
    this.props.onChange({ formValues });
  }

  changeEmail(e) {
    this.emit({ destinationEmail: e.target.value });
  }

  changeReservationId(e) {
    this.emit({ reservationId: e.target.value });
  }

  changeMotor(e) {
    this.emit({ motor: e.target.value });
  }

  render() {
    const { isAggregator, motors } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          // swal-content ships a fixed 20px side padding; pull back 4px each side so the fields
          // align to the modal's 16px gutter (same as .swal-title) instead of overflowing.
          margin: "0 -4px",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 8,
          }}>
          <input
            style={{ padding: 5, flex: 1, minWidth: 0, boxSizing: "border-box" }}
            placeholder={this.props.intl.formatMessage(messages.destinationEmail)}
            value={this.state.destinationEmail}
            onChange={this.changeEmail.bind(this)}
          />
          <input
            style={{ padding: 5, flex: 1, minWidth: 0, boxSizing: "border-box" }}
            placeholder={this.props.intl.formatMessage(messages.reservationId)}
            value={this.state.reservationId}
            onChange={this.changeReservationId.bind(this)}
          />
        </div>
        {isAggregator && motors && motors.length > 0 && (
          <label style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
            {this.props.intl.formatMessage(messages.motor)}
            <select
              style={{ padding: 5, boxSizing: "border-box" }}
              value={this.state.motor || ""}
              onChange={this.changeMotor.bind(this)}>
              {motors.map(ticker => (
                <option key={ticker} value={ticker}>
                  {ticker}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
    );
  }
}

SwalTestEmailForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  destinationEmail: PropTypes.string,
  reservationId: PropTypes.string,
  motor: PropTypes.string,
  motors: PropTypes.arrayOf(PropTypes.string),
  isAggregator: PropTypes.bool,
};

SwalTestEmailForm.defaultProps = {
  motors: [],
  isAggregator: false,
};

export default SwalTestEmailForm;
